// extracted by mini-css-extract-plugin
export default {"form_heading":"social_form_heading__QWzB4","form_headingStrongUpper":"social_form_headingStrongUpper__Fwn+x","submit_button":"social_submit_button__KRiNp"};